var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "group",
    viewBox: "0 0 41 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M37.647 0.941c-2.089-0.659-4.386-0.941-6.588-0.941-3.671 0-7.624 0.753-10.353 2.824-2.729-2.071-6.682-2.824-10.353-2.824s-7.624 0.753-10.353 2.824v27.576c0 0.471 0.471 0.941 0.941 0.941 0.188 0 0.282-0.094 0.471-0.094 2.541-1.224 6.212-2.071 8.941-2.071 3.671 0 7.624 0.753 10.353 2.824 2.541-1.6 7.153-2.824 10.353-2.824 3.106 0 6.306 0.565 8.941 1.976 0.188 0.094 0.282 0.094 0.471 0.094 0.471 0 0.941-0.471 0.941-0.941v-27.482c-1.129-0.847-2.353-1.412-3.765-1.882zM37.647 26.353c-2.071-0.659-4.329-0.941-6.588-0.941-3.2 0-7.812 1.224-10.353 2.824v-21.647c2.541-1.6 7.153-2.824 10.353-2.824 2.259 0 4.518 0.282 6.588 0.941v21.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M31.059 11.294c1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.282-3.087-0.452-4.706-0.452-3.2 0-6.099 0.546-8.471 1.562v3.125c2.127-1.205 5.082-1.864 8.471-1.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M22.588 15.040v3.125c2.127-1.205 5.082-1.864 8.471-1.864 1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.282-3.087-0.452-4.706-0.452-3.2 0-6.099 0.565-8.471 1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M31.059 18.504c-3.2 0-6.099 0.546-8.471 1.562v3.125c2.127-1.205 5.082-1.864 8.471-1.864 1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.301-3.087-0.452-4.706-0.452z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 38 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M18.824 5.064l9.412 8.471v14.701h-3.765v-11.294h-11.294v11.294h-3.765v-14.701l9.412-8.471zM18.824 0l-18.824 16.941h5.647v15.059h11.294v-11.294h3.765v11.294h11.294v-15.059h5.647l-18.824-16.941z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.d54a8fb994cb406724ce41cfe1822b34.svg";
export { ForwardRef as ReactComponent };